var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 12.7 12.7"
    },
    viewBox: "0 0 12.7 12.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3 3.3C3 1.5 4.5 0 6.3 0s3.3 1.5 3.3 3.3-1.4 3.4-3.3 3.4S3 5.2 3 3.3zm6.1 4.1c-.4-.1-.8-.1-1.1.1-1 .6-2.3.6-3.3 0-.3-.2-.7-.2-1.1-.1-1.3.3-2.3 1.5-2.3 2.9v.7c0 .4.1.8.3 1.2.2.3.5.5.9.5h7.6c.4 0 .7-.2.9-.5.2-.4.3-.8.3-1.2v-.7c0-1.4-.9-2.6-2.2-2.9z",
    style: {
      fill: "#21816A"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.54f588d89e7d2d36f49022a13b1a329e.svg";
export { ForwardRef as ReactComponent };